export default __webpack_public_path__ + "fc5c42b26348ece85126f82847c82f01.png";